import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import Layout from '@/common/Layout';
import ListView from '@/pages/ListView/components';
import styles from './index.module.less';
// import NotificationSystem from '../SocketFiles/componenets/NotificationSystem';
import { useDispatch, useSelector } from 'react-redux';
import { get_byID, get_listView, getAIData_list } from './redux/slice';
import { send_request_list, short_list } from '../ProfileView/redux/slice';
import { likeProfile, unlikeProfile } from './redux/slice';
//
const index = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('1');
  // console.log('activeTab', activeTab);

  useEffect(() => {
    fetchTabData(activeTab);
  }, [activeTab, likeProfile, unlikeProfile]);

  const {
    user_data,
    list_data,
    list_pagination,
    list_AIdata,
    aiacceptedLoading,
    user_payment_data
  } = useSelector((state) => state.listDashboard);
  // const { search_details } = useSelector((state) => state.searchresults);
  console.log('user_payment_data4567', user_payment_data);
  // const handlegetAIData = () => {
  //   console.log('Parent API called!');
  //   const payload = userId;
  //   dispatch(getAIData_list(payload));
  // };

  useEffect(() => {
    get_listby_id();
    // get_list_view();
  }, []);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  // console.log('MAT-User', userId);

  const get_listby_id = () => {
    const payload = userId;
    dispatch(get_byID(payload));
    // dispatch(getAIData_list());
  };

  // const get_list_view = () => {
  //   const payload = {
  //     category: 'all'
  //   };
  //   dispatch(get_listView(payload));
  // };

  const fetchTabData = (tabKey) => {
    // console.log('tabKey', tabKey);
    if (tabKey !== '5') {
      const category =
        tabKey === '1'
          ? 'all'
          : tabKey === '2'
          ? 'new'
          : tabKey === '3'
          ? 'sent-requests'
          : tabKey === '4'
          ? 'favourites'
          : tabKey === '7'
          ? 'shortlists'
          : tabKey === '8'
          ? 'received-requests'
          : 'others';

      dispatch(get_listView({ category }));
    } else {
      // const payload = userId;
      // dispatch(getAIData_list(payload));
    }
  };

  const handlegetAIData = () => {
    // console.log('AI API called!');
    if (!userId) {
      console.error('User ID is missing!');
      return;
    }
    // console.log('Parent API called!', userId);
    dispatch(getAIData_list(userId)); // Ensure payload is passed
  };

  const handleProfileAction = async (data) => {
    // console.log('Data from UserView:', data);

    if (data.action === 'send_request') {
      const payload = { request_to_profile_id: data.profile_id };
      dispatch(send_request_list(payload));
    } else if (data.action === 'short_profile') {
      const payload = { shortlisted_profile_id: data.profile_id };
      dispatch(short_list(payload));
    }
  };

  const handleLikeAction = async (
    profileId,
    actionType,
    sourceType,
    selectedTab
  ) => {
    // console.log(
    //   'Profile ID:',
    //   profileId,
    //   'Action:',
    //   actionType,
    //   'Source Type:',
    //   sourceType
    // );
    let payload = { profile_id: profileId };

    try {
      const response =
        actionType === 'like'
          ? await dispatch(likeProfile(payload)).unwrap()
          : await dispatch(unlikeProfile(payload)).unwrap();

      if (response?.success) {
        message.success(
          response.message || (actionType === 'like' ? 'Liked!' : 'Unliked!')
        );

        // Refresh data after the action
        // fetchTabData(activeTab);
        // handlegetAIData();
        if (sourceType === 'aiData') {
          handlegetAIData();
        } else {
          fetchTabData(selectedTab || activeTab);
        }
      }
    } catch (error) {
      console.error('Error in profile action:', error);
      message.error(error?.message || 'Failed to perform action.');
    }
  };

  const tabActive = (data) => {
    // console.log('tabActive', data);
    const category =
      data === '7'
        ? 'shortlists'
        : data === '4'
        ? 'favourites'
        : data === '3'
        ? 'sent-requests'
        : data === '8'
        ? 'received-requests'
        : data === '11'
        ? 'accepted-requests'
        : data === '12'
        ? 'rejected-requests'
        : 'others';
    dispatch(get_listView({ category }));
  };
  return (
    <>
      {/* hideHeader={true} */}
      <Layout sider={true} className={styles.layout}>
        {/* <div className={styles.notificationContainer}>
          <NotificationSystem />
        </div> */}
        <ListView
          user_data={user_data}
          list_data={list_data}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          list_pagination={list_pagination}
          handlegetAIData={handlegetAIData}
          list_AIdata={list_AIdata}
          aiacceptedLoading={aiacceptedLoading}
          onSubmit={handleProfileAction}
          likeProfile={likeProfile}
          unlikeProfile={unlikeProfile}
          onProfileAction={handleLikeAction}
          tabActive={tabActive}
          user_payment_data={user_payment_data}
        />
        {/* Settings Page */}
      </Layout>
    </>
  );
};

export default index;
